const ccpurl = 'https://javara-east.my.connect.aws/ccp-v2';

export default ccpurl;